import useNotifier from './hooks/useNotifier';

function AppNotifier() {
  useNotifier();
  return null;
}

export default AppNotifier;
